<valg-dk-page-layout
  [election]="election"
  [filterLinks]="filterLinks"
  [backLink]="breadcrumbs.previousBreadcrumb">
  <valg-dk-breadcrumbs #breadcrumbs></valg-dk-breadcrumbs>
  <div class="d-flex justify-content-between">
    <h1 *ngIf="votingDetails?.electionAreaName" class="h2 mt-0 mb-8 hyphenate">
      {{ 'page.details_page.title' | translate: { area: this.votingDetails?.electionAreaName } }}
    </h1>
    <button color="text-only" valgButton (click)="onDownloadReportClick()" class="hidden__sm">
      <mat-icon [svgIcon]="SvgIcon.Download"></mat-icon>
      {{ 'page.details_page.download-button' | translate}}
    </button>
  </div>
  <div class="row">
    <div class="col-12">
      <valg-card [border]="true" [custom]="true">
        <valg-dk-count-status title="count_status.title"
        [candidateDataLoadState]="candidateDataLoadState" [resultType]="resultType" [updated]="countStatusUpdated" [data]="countStatus"></valg-dk-count-status>
      </valg-card>
      <valg-card [border]="true" [custom]="true" class="p-0" *ngIf="election?.electionType !== ElectionType.Referendum">
        <valg-dk-expandable-party-list
          [data]="parties"
          [title]="isRmElection ? 'parties_table.candidatelist_title' : 'parties_table.title'"
          [isCandidateList]="isRmElection"
          [isMigratedElection]="isMigratedElection"
          [isElectionArea]=true
          [isCandidateListTable]="isRmElection"
          [candidateDataLoadState]="candidateDataLoadState"
          [resultType]="resultType"
        ></valg-dk-expandable-party-list>
      </valg-card>

      <valg-card [border]="true" [custom]="true" class="p-0" *ngIf="election?.electionType === ElectionType.Referendum">
        <valg-dk-referendum-status [data]="referendumStatus" [election]="election"></valg-dk-referendum-status>
      </valg-card>
    </div>
    <div class="col-12 col-lg-6">
      <valg-card [border]="true" [custom]="true">
        <valg-dk-voting-details 
        [data]="votingDetails" 
        [resultType]="resultType" 
        [candidateDataLoadState]="candidateDataLoadState"
        [isElectionArea]="true"
        [isMigratedElection]="isMigratedElection"
        ></valg-dk-voting-details>
      </valg-card>
    </div>
  </div>
</valg-dk-page-layout>
